import { investorsContentRu } from './investorsContent';

/** UI-строки (секции), не вынесенные в content.js */
export const uiRu = {
  common: {
    menu: 'Меню',
    close: 'Закрыть',
    back: 'Назад',
    forward: 'Вперёд',
  },
  brand: {
    name: 'Финансовый Центр',
    descriptor: 'Интегратор финансирования госпрограмм',
    alt: 'Финансовый центр',
  },
  about: {
    missionTitle: 'Наша миссия',
    missionText:
      'Обеспечивать эффективное и ориентированное на результат финансирование государственных программ через разработку и сопровождение цифровых, нормативных и аналитических механизмов распределения средств, основанных на данных и прозрачных правилах.',
    cards: [
      { title: 'Системность', text: 'Строим архитектуру, а не отдельные решения' },
      { title: 'Прозрачность', text: 'Правила и параметры должны быть понятны всем' },
      { title: 'Устойчивость', text: 'Механизмы масштабируемые и долгосрочные' },
      { title: 'Данные', text: 'Решения на основе расчётов и аналитики' },
    ],
    label: 'О компании',
    title: 'Новая роль в',
    titleEm: 'экосистеме',
    titleEnd: 'госфинансов',
    subtitle:
      'В 2025 году АО «Финансовый центр» вступило в этап стратегического развития. Мы становимся не только участником финансовых процессов, но и интегратором моделей, данных и правил, формирующих современную архитектуру финансирования государственных программ.',
    values: [
      { title: 'Ответственность', text: 'Финансирование - инструмент достижения общественно значимых результатов' },
      { title: 'Профессиональная глубина', text: 'Решения принимаются на основе данных, расчётов и аналитики' },
      { title: 'Интеграция', text: 'Соединяем нормативную базу, цифровые решения и аналитику в единую систему' },
    ],
  },
  pnf: {
    label: 'Подушевое нормативное финансирование',
    title: 'Финансирование',
    titleEm: 'системы образования',
    subtitle:
      'АО «Финансовый центр» сопровождает государственный образовательный заказ на всех уровнях. Нажмите на уровень образования, чтобы увидеть детали.',
    portalsStats: 'Статистика с портала orta-bilim.e-qazyna.kz',
    summaryTitle: 'Объём финансирования всех уровней образования 2026',
    tableHead: ['Уровень образования', 'Организаций', 'Контингент', 'Объём госзаказа 2026'],
    algoTitle: 'Алгоритм расчёта подушевого нормативного финансирования',
    keleshekTag: 'Единая добровольная накопительная система',
    keleshekTitle: '«Келешек» - гарантия будущего каждого ребёнка',
    keleshekDesc:
      'Система позволяет реализовать ключевые обязательства родителя - дать ребёнку квалифицированное образование, достойную профессию и решить жилищный вопрос. Основная площадка - ГОНС Aqyl.',
    keleshekFeatures: [
      'Ежегодные премии от государства',
      'Вознаграждение / инвестиционный доход',
      'Гарантирование вкладов и страхования',
      'Защита от взыскания',
      'Нет ограничений по выбору учебного заведения',
      'Нет возрастных ограничений',
    ],
    calcTitle: 'Калькулятор накоплений',
    calcLabels: {
      startCapital: 'Стартовый капитал от государства',
      parentMRP: 'Ежегодный взнос родителя',
      premium: 'Премия государства',
      bank: 'Вознаграждение банка',
      years: 'Срок накопления',
      calcBtn: 'Вычислить',
      result: 'Итого сумма накопления',
    },
    summaryRows: [
      'Дошкольное образование',
      'Среднее образование',
      'ТиПО (колледжи)',
      'ОВПО (ВУЗы)',
      'Дополнительное образование',
      'Стипендии ОВПО/ТиПО',
    ],
    totalRow: 'ИТОГО',
    summaryMeta: [
      { orgs: '11 909 садов', contingent: '988 тыс. воспитанников', budget: '~924 млрд тг' },
      { orgs: '9 193 школы', contingent: '3 964 тыс. учащихся', budget: '~3,6 трлн тг' },
      { orgs: '763 колледжа', contingent: '556 тыс. студентов', budget: '~514 млрд тг' },
      { orgs: '123 ВУЗа', contingent: '752 тыс. студентов', budget: '~504 млрд тг' },
      { orgs: '3 674 орг.', contingent: '1,15 млн обучающихся', budget: '~154 млрд тг' },
      { orgs: '-', contingent: '240 тыс. стипендиатов', budget: '~174 млрд тг' },
    ],
  },
  timeline: {
    label: 'История',
    title: 'История',
    titleEm: 'АО «Финансовый центр»',
  },
  management: {
    label: 'Руководство',
    title: 'Наша',
    titleEm: 'команда',
    tabs: {
      board: 'Совет директоров',
      pravlenie: 'Правление',
      directors: 'Руководство',
      structure: 'Организационная структура',
    },
    structureCaption: 'Организационная структура АО «Финансовый центр»',
    structureHint: 'Нажмите, чтобы увеличить',
    structureOpen: 'Открыть в новом окне',
    structureAria: 'Открыть организационную структуру',
    chairBadge: 'Председатель Правления',
    board: [
      { initials: 'СД', name: 'Рустем Куандыков', role: 'Председатель Совета директоров', tag: 'Совет директоров' },
      { initials: 'НД', name: 'Независимый директор', role: 'Аудит, риски и финансы', tag: 'Совет директоров' },
      { initials: 'НД', name: 'Независимый директор', role: 'Стратегия и развитие', tag: 'Совет директоров' },
    ],
    pravlenie: [
      { initials: 'ПП', name: 'Председатель Правления', role: 'Утельбаева Шолпан Ануарбекқызы', isChair: true },
      { initials: 'ЗП', name: 'Первый заместитель Председателя', role: 'Ерекешева Кенжегуль Капбасовна' },
      { initials: 'ЗП', name: 'Заместитель Председателя', role: 'Надирбеков Тимур Даулетулы' },
    ],
  },
  news: {
    badge: 'Актуально',
    label: 'Новости',
    title: 'Новости и',
    titleEm: 'события',
    allNews: 'Все новости',
    readMore: 'Подробнее',
    readArticle: 'Читать статью →',
    readShort: 'Читать →',
    page: 'Страница',
  },
  faq: {
    label: 'FAQ',
    title: 'Частые вопросы и',
    titleEm: 'материалы',
    subtitle:
      'Сначала - ответы в аккордеоне, ниже - «Презентации и материалы» с иконками, скачиванием и быстрым предпросмотром.',
    materialsTitle: 'Презентации и материалы',
    faqListAria: 'Частые вопросы',
    materialsAria: 'Презентации и материалы',
    preview: 'Предпросмотр',
    download: 'Скачать',
    extraFaq: [
      {
        q: 'Как подать заявку или уточнить условия по программе?',
        a: 'В зависимости от программы доступен личный кабинет ведомства/организации, либо подача через уполномоченных операторов. Для первичной консультации используйте контакты в футере и укажите программу и регион.',
      },
      {
        q: 'Где посмотреть нормативы и методологию расчёта?',
        a: 'Нормативные документы публикуются в разделе материалов и в карточках программ. Мы рекомендуем использовать последнюю редакцию и проверять дату утверждения.',
      },
      {
        q: 'Как обеспечивается прозрачность распределения средств?',
        a: 'Через единые правила расчёта, цифровые реестры получателей, верификацию данных и мониторинг показателей. Это уменьшает долю ручных решений и повышает сопоставимость параметров.',
      },
      {
        q: 'Можно ли получить презентацию/справку для руководства?',
        a: 'Да. Ниже доступен список материалов (PDF). Для актуализации под ваш кейс оставьте запрос - подготовим краткую справку и подборку приложений.',
      },
    ],
    materials: [
      { title: 'Презентация: Финансовый Центр (обзор)', meta: 'Обновлено: 2025 • 3.4 MB' },
      { title: 'Методология: нормативы и коэффициенты', meta: 'Редакция: 2025 • 1.9 MB' },
      { title: 'Отчёт: мониторинг эффективности программ', meta: 'Квартал: Q1 2025 • 4.8 MB' },
    ],
  },
  contacts: {
    label: 'Контакты',
    title: 'Остались вопросы?',
    titleEm: 'Напишите нам',
    subtitle: 'Заполните форму, и мы свяжемся с вами в течение одного рабочего дня.',
    formTitle: 'Остались вопросы?',
    formSubtitle: 'Заполните форму и мы свяжемся с вами в течение одного рабочего дня.',
    appealBtn: 'Обращение граждан',
    send: 'Отправить',
    success: 'Спасибо! Ваше обращение принято.',
    chairman: {
      name: 'Утельбаева Шолпан Ануарбековна',
      role: 'Председатель Правления',
    },
    address: 'г.Астана, 010000, пр.Мангилик Ел 18',
    hours: 'Пн-Пт: 09:00-18:00',
    phoneFree: '(бесплатно)',
    writeUs: 'Написать нам',
    openDialog: 'Открытый диалог',
    form: {
      nameLabel: 'Ваше имя *',
      phoneLabel: 'Телефон *',
      emailLabel: 'Email',
      messageLabel: 'Сообщение',
      agreeLabel: 'Я даю согласие на обработку персональных данных',
      namePlaceholder: 'Иванов Иван',
      phonePlaceholder: '+7 (___) ___-__-__',
      emailPlaceholder: 'example@mail.kz',
      messagePlaceholder: 'Ваш вопрос или комментарий',
      errName: 'Введите имя',
      errPhone: 'Введите телефон',
      errAgree: 'Нужно согласие',
      thanksTitle: 'Спасибо!',
      thanksSub: 'Мы свяжемся с вами в течение одного рабочего дня.',
    },
    appeal: {
      title: 'Подать обращение',
      category: 'Категория обращения',
      description: 'Описание',
      descPlaceholder: 'Ваш вопрос',
      chars: 'символов (минимум 25)',
      lastName: 'Фамилия',
      firstName: 'Имя',
      patronymic: 'Отчество (при наличии)',
      patronymicShort: 'Отчество',
      submit: 'Подать обращение',
      successTitle: 'Обращение отправлено!',
      successSub: 'Мы рассмотрим ваше обращение и свяжемся с вами.',
    },
    categories: [
      'Строительство/реконструкция студенческих общежитий',
      'Строительство/реконструкция',
      'Подушевое нормативное финансирование',
      'Депозит "Aqyl"',
      'Отработка гранта',
      'Возврат образовательных кредитов',
      'Начисление стипендии',
      'Связь с пресс-службой',
      'Другое',
    ],
  },
  footer: {
    about:
      'АО «Финансовый центр» - институт, соединяющий традиции государственного управления с современными цифровыми инструментами.',
    nav: 'Навигация',
    contacts: 'Контакты',
    materials: 'Материалы',
    copy: '© 2025 АО «Финансовый центр». Все права защищены.',
    links: {
      news: 'Новости',
      programs: 'Программы',
      faq: 'FAQ',
      contacts: 'Контакты',
      presentations: 'Презентации (PDF)',
      funding: 'Финансирование госпрограмм',
      history: 'История',
    },
  },
  newRole: {
    badge: 'Трансформация',
    title: 'Стратегия трансформации финансирования образования',
    subtitle:
      'Переход от затратной модели к инвестициям в человеческий капитал с фокусом на прозрачность, измеримость и единую цифровую экосистему.',
    goal: 'Цель',
    goalText:
      'Создание управляемой, измеримой и защищенной от нецелевых расходов системы финансирования.',
    vision: 'Видение 2028',
    visionText: 'Формирование инвестиционной модели финансирования образования Казахстана.',
    pillarsTitle: 'Инвестиционная модель 2028 года',
    roadmapTitle: 'Дорожная карта трансформации',
    ecosystemTitle: 'Унификация цифровой экосистемы',
    before: 'Ранее: фрагментация в 8 системах',
    after: 'Сейчас: единый портал e-Qazyna.kz',
    pillars: [
      { title: 'Data Hub', desc: 'Единая система аналитики, сбор и верификация данных по всем уровням образования.' },
      { title: 'Прозрачность', desc: 'Управляемая, измеримая и защищенная от нецелевых расходов модель финансирования.' },
      { title: 'Индекс', desc: 'Переход к индикаторной модели оценки качества, устойчивости и результативности.' },
      { title: 'Ваучер', desc: 'Механизмы, где финансирование следует за получателем услуги.' },
      { title: 'Инвестиции (KASE, DAMU)', desc: 'Привлечение частного капитала и запуск рынка образовательных инвестиций.' },
      { title: 'Оценка эффективности', desc: 'Оценка аккредитационной деятельности и управленческих результатов в цифре.' },
    ],
    roadmap: [
      { title: 'Полная оцифровка (2026)', desc: 'Перевод данных в государственный реестр, единая цифровая база организаций образования и интеграция источников информации.' },
      { title: 'Карта данных (2026)', desc: 'Создание аналитической системы, ежеквартальный сбор и анализ данных, запуск аналитических дашбордов.' },
      { title: 'Пересмотр методологии ПНФ (2026-2027)', desc: 'Ревизия тарифов и нормативов, обновление норм и методологии расчётов, цифровизация моделей.' },
      { title: 'Индикаторная модель (2027)', desc: 'Управление на основе измеримых показателей качества, устойчивости и результативности организаций.' },
      { title: 'Токенизация знаний (2028)', desc: 'Оцифровка образовательных результатов и переход к финансированию, основанному на результатах.' },
      { title: 'Токенизация как облигации (2028)', desc: 'Выпуск инвестиционных токенов (бонды), привлечение частного капитала и формирование рынка инвестиций.' },
    ],
    beforeSystems: ['LMS', 'УМОСК', 'ЭГЗ', 'ИСГП', 'НОБД', 'ЭСФ', 'ИС БВУ', 'ИСКК'],
    afterSystems: ['Лицензии / разрешительные документы', 'Заявки', 'Бюджет', 'Договоры'],
  },
  workingOff: {
    label: 'Студентам',
    title: 'Отработка государственных образовательных грантов',
    subtitle: 'Выберите нужный подраздел, чтобы открыть информацию прямо на сайте.',
  },
  investors: {
    label: 'Инвесторам',
    title: 'Инвестиционные',
    titleEm: 'проекты',
    tabs: ['Условия проекта', 'Нормативы', 'Алгоритм размещения', 'Поддержка'],
    ...investorsContentRu,
  },
  a11y: {
    panel: 'Настройки версии для слабовидящих',
    exit: 'Обычная версия',
    font: 'Шрифт',
    fontGroup: 'Размер шрифта',
    decreaseFont: 'Уменьшить шрифт',
    resetFont: 'Сбросить размер шрифта',
    increaseFont: 'Увеличить шрифт',
    visionToggle: 'Версия для слабовидящих',
  },
  hero: { scroll: 'Scroll' },
};
